export const diasDisponiblesArray = [
  {
    id: 0,
    descripcion: "Todos",
    checked: true,
  },
  {
    id: 1,
    descripcion: "Lunes",
    checked: false,
  },
  {
    id: 2,
    descripcion: "Martes",
    checked: false,
  },
  {
    id: 3,
    descripcion: "Miércoles",
    checked: false,
  },
  {
    id: 4,
    descripcion: "Jueves",
    checked: false,
  },
  {
    id: 5,
    descripcion: "Viernes",
    checked: false,
  },
  {
    id: 6,
    descripcion: "Sábado",
    checked: false,
  },
  {
    id: 7,
    descripcion: "Domingo",
    checked: false,
  },
];

export const horarioDisponibleArray = [
  {
    id: 0,
    descripcion: "Todos",
    checked: true,
  },
  {
    id: 1,
    descripcion: "7:30 a 10hs",
    rango: "730|1000",
    checked: false,
  },
  {
    id: 2,
    descripcion: "10 a 12hs",
    rango: "1000|1200",
    checked: false,
  },
  {
    id: 3,
    descripcion: "12 a 14hs",
    rango: "1200|1400",
    checked: false,
  },
  {
    id: 4,
    descripcion: "14 a 16hs",
    rango: "1400|1600",
    checked: false,
  },
  {
    id: 5,
    descripcion: "16 a 18hs",
    rango: "1600|1800",
    checked: false,
  },
  {
    id: 6,
    descripcion: "18 a 20hs",
    rango: "1800|2000",
    checked: false,
  },
];
